// client/src/pages/TestimonialsPage.js — public testimonials: only those the client
// consented to publish and the managing broker approved.
import React, { useEffect, useState } from 'react';

const TestimonialsPage = () => {
    const [rows, setRows] = useState(null);
    useEffect(() => {
        fetch('/api/reviews/public/testimonials').then((r) => (r.ok ? r.json() : [])).then(setRows).catch(() => setRows([]));
    }, []);
    return (
        <div className="container mx-auto px-6 py-12 max-w-3xl">
            <h1 className="text-3xl font-bold text-slate-800 mb-6">What our clients say</h1>
            {rows === null ? <p className="text-slate-500">Loading…</p>
                : rows.length === 0 ? <p className="text-slate-500">No testimonials published yet.</p>
                    : <div className="space-y-4">{rows.map((t) => (
                        <figure key={t.testimonial_id} className="bg-white rounded-lg shadow p-5">
                            {t.rating ? <div className="text-amber-500" aria-label={`${t.rating} of 5`}>{'★'.repeat(t.rating)}{'☆'.repeat(5 - t.rating)}</div> : null}
                            <blockquote className="text-slate-800 whitespace-pre-wrap mt-1">{t.body}</blockquote>
                            <figcaption className="text-sm text-slate-500 mt-2">— {t.display_name}{t.agent_name ? `, client of ${t.agent_name}` : ''}</figcaption>
                        </figure>))}</div>}
            <p className="text-xs text-slate-400 mt-8">Testimonials are published with each client's written consent. Individual experiences vary.</p>
        </div>
    );
};

export default TestimonialsPage;
